import React, { useState } from 'react'
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";
import styles from "./SupervisorReportsDetails.module.css"
import { SubmitButton } from '../../../../components';
import { Dropdown, InputField, SearchInput, TextComponent, Modal } from "../../../../components";
import { Image } from 'antd';


const SupervisorReportsDetails = () => {
    const [isModal, setIsModal] = useState(false)
    const [adviceModal, setAdviceModal] = useState(false)
    const [advice, setAdvice] = useState("");
    const data = [
        {
            tag: "Task ID",
            value: "#123"
        },

        {
            tag: "Product Name",
            value: "Ciabatta – 44 lbs"
        },
        {
            tag: "Station",
            value: "Mixing"
        },
        {
            tag: "Reportee",
            value: "John Doe"
        },
        {
            tag: "Date",
            value: "08/11/2025"
        },
        {
            tag: "Time",
            value: " 08:30 AM"
        },
        {
            tag: "Status",
            value: "Approved"
        },
        {
            tag: "What kind of issue are you facing?",
            value: "Missing Ingredient"
        },
        {
            tag: " Description",
            value: "Water line pressure is low — can’t reach correct temp. Grain mix not soaked in time."
        },
        {
            tag: "Photo",
            value: "https://media.istockphoto.com/id/518468635/photo/french-pastries-on-display-a-confectionery-shop.jpg?s=612x612&w=0&k=20&c=av7rYRCLckvDp6s9sGmA_S9Lp_fTSDSSOtmR0wWJ8nY="
        },

    ]

    return (
        <div>
            <HeaderComponent
                heading="Details"
                showBackIcon={true}
            />
            <div className={styles.mainCont}>
                {/* {data.map((item) => (
                    <div className={styles.detailsCont}>
                        <TextComponent className={styles.detLabel} text={item.tag}/> 
                        <TextComponent className={styles.delTag} text={item.value}/> 
                    </div>
                ))} */}

                {data.map((item) => (
                    <div className={styles.detailsCont} key={item.tag}>

                        <TextComponent
                            className={styles.detLabel}
                            text={item.tag}
                        />
                        {Array.isArray(item.value) ? (
                            <Image.PreviewGroup>
                                <div className={styles.images}>
                                    {item.value.map((imgSrc, idx) => (
                                        <Image
                                            className={styles.qc_image}
                                            key={idx}
                                            width={80}
                                            src={imgSrc}
                                            alt={`${item.tag}-${idx}`}
                                        />
                                    ))}
                                </div>
                            </Image.PreviewGroup>
                        ) : item.tag === "Photo" ? (
                            <Image
                                className={styles.qc_image}
                                width={80}
                                src={item.value}
                                alt={item.tag}
                            />
                        ) : (
                            <TextComponent
                                className={styles.delTag}
                                text={item.value || "-"}
                            />
                        )}

                    </div>
                ))}


                <div className={styles.BtnCont}>
                    <SubmitButton
                        title={"Reject"}
                        btnClass={styles.actionBtn}
                        btnContainerClass={styles.BtnClass}
                        onClick={() => {
                            setIsModal(true);
                        }}

                    />

                    <SubmitButton
                        title={"Approve"}
                        primary
                        // btnClass={styles.actionBtn}
                        btnContainerClass={styles.BtnClass}
                        onClick={() => {
                            setIsModal(true);
                        }}

                    />

                    <SubmitButton
                        title={"Advise"}
                        secondary
                        btnClass={styles.actionBtn}
                        btnContainerClass={styles.BtnClass}
                        onClick={() => {
                            setAdviceModal(true);
                        }}
                    />
                </div>
            </div>


            {/* /////////confirm modal ///////////////////// */}

            <Modal
                open={isModal}
                onCancel={() => { setIsModal(false) }}
                onClickOkButton={() => {
                    setIsModal(false);
                }}
                className={styles.modalCont}
                title={"Confirm Decision"}
                headingClass={styles.modalHeading}
                width={"400px"}
                // btnStyle={{ width: "200px", }}
                twoButton
                okBtnTitle={"Confirm"}
                cancelBtnTitle={"Cancel"}
                onClickCancelButton={() => setIsModal(false)}
                type={"password"}
            // onBtnPress={() => setLimitExceedsModal(false)}
            >
                <TextComponent
                    text="Your action will alert the related parties and cannot be undone."
                    className={styles.CardText}
                />


            </Modal>

            {/* ///////// advice modal ///////////////////// */}

            <Modal
                open={adviceModal}
                onCancel={() => { setAdviceModal(false) }}
                onClickOkButton={() => {
                    setAdviceModal(false);
                }}
                className={styles.modalCont}
                title={"Advise"}
                headingClass={styles.modalHeading}
                width={"400px"}
                // btnStyle={{ width: "200px", }}
                twoButton
                okBtnTitle={"send"}
                cancelBtnTitle={"Cancel"}
                onClickCancelButton={() => setAdviceModal(false)}
            // onBtnPress={() => setLimitExceedsModal(false)}
            >
                <InputField
                    placeholder={" Give a Solution"}
                    innerInput={{ width: "" }}
                    value={advice}
                    onChange={(e) => setAdvice(e.target.value)}
                />
            </Modal>

        </div>
    )
}

export default SupervisorReportsDetails
